"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlockStatus = void 0;
/**
 * 块状态
 */
var BlockStatus;
(function (BlockStatus) {
    BlockStatus[BlockStatus["NORMAL"] = 1] = "NORMAL";
    BlockStatus[BlockStatus["DELETED"] = -1] = "DELETED";
    BlockStatus[BlockStatus["DELETED_COMPLETE"] = -2] = "DELETED_COMPLETE";
})(BlockStatus = exports.BlockStatus || (exports.BlockStatus = {}));
